module.exports = __webpack_public_path__ + "static/calendar.cbb7e3e4.svg";